import { Facebook, Link as LinkIcon, Mail, Rss, Twitter } from "react-feather"
import { useTranslation } from "react-i18next"
import { toast } from "react-toastify"
import copy from "copy-to-clipboard"

import Link from "~/components/Link"
import { getArticlesRSSFeedURL } from "~/utils/articles/getArticlesRSSFeedURL"
import { publicConfig } from "~/utils/config"
import { getShareURLs } from "~/utils/social/sharing"

export type ShareLinksProps = {
  title: string
  path: string
}

export const ShareLinks: React.FC<ShareLinksProps> = ({ title, path }) => {
  const { t } = useTranslation(["articlePage", "general"])
  const urls = getShareURLs({
    twitterUsername: publicConfig.socialMedia.twitter.username,
    path,
    text: title,
  })

  return (
    <>
      <button
        onClick={() => {
          copy(getArticlesRSSFeedURL(), { format: "text/plain" })
          toast(t("general:copiedToClipboard.url"))
        }}
        type="button"
      >
        <Rss id="share-links-rss-icon" strokeWidth={1.5} />
        <span className="sr-only">{t("articlePage:subscribeToRSS")}</span>
      </button>

      <Link href={urls.mailto} isExternal>
        <Mail id="share-links-mail-icon" strokeWidth={1.5} />
        <span className="sr-only">{t("articlePage:shareWith.email")}</span>
      </Link>

      <Link href={urls.facebookURL} isExternal>
        <Facebook id="share-links-facebook-icon" strokeWidth={1.5} />
        <span className="sr-only">{t("articlePage:shareWith.facebook")}</span>
      </Link>

      <Link href={urls.twitterURL} isExternal>
        <Twitter id="share-links-twitter-icon" strokeWidth={1.5} />
        <span className="sr-only">{t("articlePage:shareWith.twitter")}</span>
      </Link>

      <button
        onClick={() => {
          copy(urls.url, { format: "text/plain" })
          toast(t("general:copiedToClipboard.url"))
        }}
        type="button"
      >
        <LinkIcon id="share-links-link-icon" strokeWidth={1.5} />
        <span className="sr-only">{t("articlePage:shareWith.link")}</span>
      </button>
    </>
  )
}
